// extracted by mini-css-extract-plugin
module.exports = {"link":"e2ff468f85--link--fKr7E"};